import { useOwnersAdminStore } from '@/stores/OwnersAdminStore'

// A aba "Criar Owner Mãe" só deve ser acessível para owners cujo id esteja na
// allowlist do .env (OWNER_MASTER_CREATOR_IDS, refletido em context.is_allowlisted_creator).
// Se um usuário de uma owner fora da allowlist forçar a entrada nessa rota, ele é
// redirecionado para a criação de owners filhas em vez de ver uma tela de erro.
export const CreateMotherOwnerGuard = async (to, from, next) => {
  const ownersAdminStore = useOwnersAdminStore()

  await ownersAdminStore.FetchOwnerContext()

  if (!ownersAdminStore.canCreateMother) {
    return next({ name: 'admin-owners-criar-filho' })
  }

  next()
}
